// Window ready
window.addEventListener('load', function () {

	// If is iPad
	if (window.getURLParameter("ipad") != null) {

		// iPad stylesheet
		var fileref = document.createElement("link");
		fileref.rel = "stylesheet";
		fileref.type = "text/css";
		fileref.href = "css/ipad.css";
		document.getElementsByTagName("head")[0].appendChild(fileref)

		// On resize
		$(window).resize(function () {
			var ww = $(window).width();
			var wh = $(window).height();
			var sw = ww / 1920;
			var sh = sw;
			console.log("resize", $("#game"));
			$("#game").css("transform", "translate(-50%, -50%) scale(" + sw + ", " + sh + ")");
		});
	}

	// Trigger resize
	$(window).trigger("resize");

}, false);
